//#region importsSection
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Spinner,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import swal from "sweetalert";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { ApiDocuments } from "../documents/ApiDocuments";
import { ApiFinance } from "../funds/ApiFinance";
import { LoadingSpinner } from "../../constants/const";
//#endregion

//#region styles
const labelStyle = {
  fontSize: "12px",
  color: "#6B7280",
  marginBottom: "2px",
  lineHeight: "1.15",
};

const valueStyle = {
  fontSize: "14px",
  fontWeight: 500,
  color: "#1F2937",
  lineHeight: "1.25",
};

const cardBase = {
  borderRadius: "12px",
  border: "1px solid #E5E7EB",
};

const sectionHeader = (color) => ({
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: "0.04em",
  color,
  textTransform: "uppercase",
  marginBottom: "10px",
});

const animatedBody = {
  animation: "fadeSlideIn 0.25s ease-out",
};

const amountBadge = (bgColor = "#D1FAE5", textColor = "#059669") => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: "12px",
  backgroundColor: bgColor,
  color: textColor,
  fontWeight: 600,
  fontSize: "13px",
});
//#endregion

const TransactionTransferNotificationModal = ({
  setViewFinanceNotificationModel,
  notificationId,
}) => {
  const [notificationresponse, setNotificationresponse] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const toggle = () => setViewFinanceNotificationModel(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleDrag = (e, ui) =>
    setPosition((p) => ({ x: p.x + ui.deltaX, y: p.y + ui.deltaY }));
  const [viewButtonDisable, setViewButtonDisable] = useState(
    Array(notificationresponse.expenses?.length).fill(false)
  );
  const [buttonDisable, setButtonDisable] = useState(
    Array(notificationresponse.expenses?.length).fill(false)
  );
  useEffect(() => {
    if (!notificationId) return;
    setLoading(true);
    ApiFinance()
      .GetTransferDataForNotification(notificationId)
      .then((res) => setNotificationresponse(res.data || {}))
      .finally(() => setLoading(false));
  }, [notificationId]);

  const openFile = (fileUrl, index) => {
    setViewButtonDisable((prevStates) => {
      const newLoadingStates = [...prevStates];
      newLoadingStates[index] = true;
      return newLoadingStates;
    });

    try {
      window.open(fileUrl, "_blank");
    } catch (err) {
      swal({
        title: "Error opening file",
        icon: "error",
        buttons: "OK",
      });
      console.error(err);
    }

    // Stop loader
    setViewButtonDisable((prevStates) => {
      const newLoadingStates = [...prevStates];
      newLoadingStates[index] = false;
      return newLoadingStates;
    });
  };

  const downloadFile = async (fileId, index) => {
    // Set loading state
    setButtonDisable((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = true;
      return newStates;
    });

    try {
      const response = await ApiDocuments().downloadDocument(fileId);
      if (response.status === 200) {
        const modifiedLink = `${response.data.downloadLink}&confirm=t`;

        window.location.href = modifiedLink;
      } else {
        swal({
          title: t(response.data),
          icon: "error",
          buttons: "OK",
        });
        console.error("Error getting download link:", response.data);
      }
    } catch (error) {
      swal({
        title: error.message,
        icon: "error",
        buttons: "OK",
      });
    } finally {
      // Reset button state
      setButtonDisable((prevStates) => {
        const newStates = [...prevStates];
        newStates[index] = false;
        return newStates;
      });
    }
  };

  return (
    <>
      {/* animation keyframes */}
      <style>
        {`
          @keyframes fadeSlideIn {
            from {
              opacity: 0;
              transform: translateY(8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal size="xl" isOpen className="inmodal">
          <ModalHeader className="modal-title">
            <GetLanguageString props="common_changes" />
          </ModalHeader>

          {loading ? (
            <ModalBody className="text-center py-4">
              <LoadingSpinner />
            </ModalBody>
          ) : (
            <ModalBody style={animatedBody}>
              {/* TRANSFER INFO */}
              <Card
                className="mb-3"
                style={{
                  ...cardBase,
                  background: "#ECFDF5",
                  borderLeft: "5px solid #10B981",
                }}
              >
                <CardBody>
                  <div style={sectionHeader("#059669")}>
                    Transfer Information
                  </div>
                  <Row className="gy-3">
                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="dashboard_event_page_unit_name" />
                      </div>
                      <div className="ur" style={valueStyle}>
                        {notificationresponse.unitName}
                      </div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="member_report_from" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.fromAccount}
                      </div>
                    </Col>

                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="member_report_to" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.toAccount}
                      </div>
                    </Col>
                    <Col md="4" className="">
                      <div style={labelStyle}>
                        <GetLanguageString props="funds_add_fund_amount" />
                      </div>
                      <div style={amountBadge("#D1FAE5", "#059669")}>
                        {new Intl.NumberFormat().format(
                          notificationresponse.transferAmount || 0
                        )}
                      </div>
                    </Col>

                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="dashboard_event_page_date" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.requestDate
                          ? new Date(
                              notificationresponse.requestDate
                            ).toLocaleDateString("en-GB")
                          : ""}
                      </div>
                    </Col>
                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_memo" />
                      </div>
                      <div style={valueStyle}>{notificationresponse.memo}</div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* BANK INFO */}
              <Card
                className="mb-3"
                style={{
                  ...cardBase,
                  background: "#EFF6FF",
                  borderLeft: "5px solid #3B82F6",
                }}
              >
                <CardBody>
                  <div style={sectionHeader("#2563EB")}>
                    <GetLanguageString props="transactions_beneficiary_details" />
                  </div>

                  <Row className="gy-3">
                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_account_title" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.rafiqAccountTitle}
                      </div>
                    </Col>

                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_account_number" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.rafiqAccountNumber}
                      </div>
                    </Col>

                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_bank_name" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.rafiqBankName}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* ATTACHMENT */}
              {notificationresponse.shuraApprovalFile && (
                <Card
                  className="mb-3"
                  style={{
                    ...cardBase,
                    background: "#F0F9FF",
                    borderLeft: "5px solid #0EA5E9",
                  }}
                >
                  <CardBody className="d-flex justify-content-between align-items-center">
                    <div>
                      <div style={sectionHeader("#0284C7")}>
                        <GetLanguageString props="attachment" />
                      </div>
                      <div style={valueStyle}>
                        <GetLanguageString props="transactions_shura_approval_attachment" />
                      </div>
                    </div>

                    <div className="no-drag">
                      {(() => {
                        const shuraIndex = notificationresponse.expenses
                          ? notificationresponse.expenses.length
                          : 0;
                        return (
                          <>
                            <Button
                              color="white"
                              disabled={viewButtonDisable[shuraIndex]}
                              size="sm"
                              onClick={() =>
                                openFile(
                                  notificationresponse.shuraApprovalFile,
                                  shuraIndex
                                )
                              }
                            >
                              {viewButtonDisable[shuraIndex] ? (
                                <Spinner size="sm" color="dark" />
                              ) : (
                                <>
                                  <i className="fa fa-eye"></i>{" "}
                                  <GetLanguageString props="member_add_rafiq_request_view_document" />
                                </>
                              )}
                            </Button>{" "}
                            <Button
                              color="white"
                              size="sm"
                              disabled={buttonDisable[shuraIndex]}
                              onClick={() =>
                                downloadFile(
                                  notificationresponse.shuraApprovalFileDriveId,
                                  shuraIndex
                                )
                              }
                            >
                              {buttonDisable[shuraIndex] ? (
                                <Spinner size="sm" color="dark" />
                              ) : (
                                <>
                                  <i className="fa fa-download"></i>{" "}
                                  <GetLanguageString props="member_add_rafiq_request_download_document" />
                                </>
                              )}
                            </Button>
                          </>
                        );
                      })()}
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* EXPENSES */}
              {notificationresponse.expenses?.length > 0 && (
                <Card style={cardBase}>
                  <CardBody>
                    <div style={sectionHeader("#2563EB")}>
                      <GetLanguageString props="sidebar_funds_expenses" />
                    </div>

                    <Table responsive className="mb-0 align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>
                            <GetLanguageString props="sidebar_funds_expense" />
                          </th>
                          <th>
                            <GetLanguageString props="funds_add_fund_amount" />
                          </th>
                          <th>
                            <GetLanguageString props="dashboard_event_page_date" />
                          </th>
                          <th>
                            <GetLanguageString props="transactions_expense_type" />
                          </th>
                          <th className="text-center">
                            <GetLanguageString props="transactions_expense_receipt" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {notificationresponse.expenses.map((x, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{x.description}</td>
                            <td>
                              <span style={amountBadge("#DBEAFE", "#2563EB")}>
                                {x.amount}
                              </span>
                            </td>
                            <td>
                              {notificationresponse.requestDate
                                ? new Date(x.date).toLocaleDateString("en-GB")
                                : ""}
                            </td>

                            <td>
                              {x.expenseType
                                ? x.expenseType.charAt(0).toUpperCase() +
                                  x.expenseType.slice(1)
                                : ""}
                            </td>

                            <td className="text-center">
                              {x.expenseFile && (
                                <>
                                  <Button
                                    color="white"
                                    disabled={viewButtonDisable[i]}
                                    size="sm"
                                    onClick={() => openFile(x.expenseFile, i)}
                                  >
                                    {viewButtonDisable[i] ? (
                                      <Spinner size="sm" color="dark" />
                                    ) : (
                                      <>
                                        <i class="fa fa-eye"></i>{" "}
                                        <GetLanguageString props="member_add_rafiq_request_view_document" />
                                      </>
                                    )}
                                  </Button>
                                  <Button
                                    color="white"
                                    size="sm"
                                    disabled={buttonDisable[i]}
                                    onClick={() =>
                                      downloadFile(x.expenseFileDriveId, i)
                                    }
                                  >
                                    {buttonDisable[i] ? (
                                      <Spinner size="sm" color="dark" />
                                    ) : (
                                      <>
                                        <i class="fa fa-download"></i>{" "}
                                        <GetLanguageString props="member_add_rafiq_request_download_document" />
                                      </>
                                    )}
                                  </Button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              )}
            </ModalBody>
          )}

          <ModalFooter>
            <Button color="primary" onClick={toggle}>
              <GetLanguageString props="users_role_ok_btn" />
            </Button>
          </ModalFooter>
        </Modal>
      </Draggable>
    </>
  );
};

export default TransactionTransferNotificationModal;
